import React, { useState } from 'react';
import './ContactSection.css';

const ContactSection = () => {
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    phone: '',
    machine: '',
    requirements: ''
  });

  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Enquiry submitted:', formData);
    setSubmitted(true);
    setTimeout(() => {
      setSubmitted(false);
      setFormData({
        fullName: '',
        email: '',
        phone: '',
        machine: '',
        requirements: ''
      });
    }, 4000);
  };

  return (
    <section className="contact-section" id="contact-us">
      <div className="contact-container">

        {/* Top Header Block: Small Label + Main Heading (Left) & Supporting Text (Right) */}
        <div className="contact-top-row">
          <div className="contact-header-left">
            <span className="contact-tag">LET'S CONNECT</span>
            <h2 className="contact-main-heading">
              Let's Discuss Your Machinery Requirements
            </h2>
          </div>

          <div className="contact-header-right">
            <p className="contact-supporting-text">
              Looking for the right CNC or industrial machine for your business? Get in touch with our team. Share your requirements and we'll help you find the right solution.
            </p>
          </div>
        </div>

        {/* Main Combined Card Block (Form Left, Dark Info Box Right) */}
        <div className="contact-combined-card">

          {/* Left Column: Form Area (White Background) */}
          <div className="contact-form-area">
            <h3 className="contact-form-title">Send Us Your Enquiry</h3>

            {submitted ? (
              <div className="contact-form-success">
                <div className="success-icon-box">
                  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                    <polyline points="22 4 12 14.01 9 11.01"></polyline>
                  </svg>
                </div>
                <h4>Enquiry Submitted Successfully!</h4>
                <p>Thank you for reaching out. Our DEXA team will contact you shortly.</p>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="contact-form">

                {/* Name & Email Row */}
                <div className="form-row two-cols">
                  <div className="form-group">
                    <label htmlFor="fullName">Full Name</label>
                    <input
                      type="text"
                      id="fullName"
                      name="fullName"
                      value={formData.fullName}
                      onChange={handleChange}
                      placeholder="Enter your full name"
                      required
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="email">Email Address</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="Enter your email address"
                      required
                    />
                  </div>
                </div>

                {/* Phone & Machine Selection Row */}
                <div className="form-row two-cols">
                  <div className="form-group">
                    <label htmlFor="phone">Phone Number</label>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      placeholder="Enter your phone number"
                      required
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="machine">Machine / Product</label>
                    <div className="select-wrapper">
                      <select
                        id="machine"
                        name="machine"
                        value={formData.machine}
                        onChange={handleChange}
                        required
                      >
                        <option value="" disabled>Select a machine</option>
                        <option value="CNC Panel Saw Machine">CNC Panel Saw Machine</option>
                        <option value="CNC Router Machine">CNC Router Machine</option>
                        <option value="Edge Banding Machine">Edge Banding Machine</option>
                        <option value="Precision Machining Equipment">Precision Machining Equipment</option>
                        <option value="Fiber Laser Cutting Machine">Fiber Laser Cutting Machine</option>
                        <option value="Custom Industrial Machinery">Custom Industrial Machinery / Other</option>
                      </select>
                      <span className="select-arrow-icon">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                          <polyline points="6 9 12 15 18 9"></polyline>
                        </svg>
                      </span>
                    </div>
                  </div>
                </div>

                {/* Requirements Textarea */}
                <div className="form-group full-width">
                  <label htmlFor="requirements">Your Requirements</label>
                  <textarea
                    id="requirements"
                    name="requirements"
                    rows="4"
                    value={formData.requirements}
                    onChange={handleChange}
                    placeholder="Tell us about your machinery requirements..."
                    required
                  ></textarea>
                </div>

                {/* Submit Button */}
                <div className="form-submit-wrapper">
                  <button type="submit" className="contact-submit-btn">
                    Submit Enquiry
                  </button>
                </div>

              </form>
            )}
          </div>

          {/* Right Column: Dark Black Info Box (Matching Reference Image) */}
          <div className="contact-dark-info-box">
            <h3 className="dark-info-heading">Get In Touch</h3>
            
            <p className="dark-info-desc">
              Have a question about our machinery? Our team is ready to help with product information, machine selection, quotations, and enquiries.
            </p>

            <div className="dark-details-list">
              
              {/* Phone Detail Item */}
              <div className="dark-detail-item">
                <div className="dark-icon-circle">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
                  </svg>
                </div>
                <a href="tel:+919876543210" className="dark-detail-text">+91 XXXXX XXXXX</a>
              </div>

              {/* Email Detail Item */}
              <div className="dark-detail-item">
                <div className="dark-icon-circle">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                    <polyline points="22,6 12,13 2,6"></polyline>
                  </svg>
                </div>
                <a href="mailto:info@dexainnovation.com" className="dark-detail-text">info@dexainnovation.com</a>
              </div>

              {/* Address Detail Item */}
              <div className="dark-detail-item">
                <div className="dark-icon-circle">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                    <circle cx="12" cy="10" r="3"></circle>
                  </svg>
                </div>
                <span className="dark-detail-text">Chennai, Tamil Nadu, India</span>
              </div>

            </div>

            {/* Social Follow Row */}
            <div className="dark-follow-block">
              <span className="dark-follow-title">Follow</span>
              <div className="dark-social-icons">
                <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="dark-social-btn" aria-label="Facebook">
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path>
                  </svg>
                </a>
                <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="dark-social-btn" aria-label="X">
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
                  </svg>
                </a>
                <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="dark-social-btn" aria-label="LinkedIn">
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"></path>
                    <rect x="2" y="9" width="4" height="12"></rect>
                    <circle cx="4" cy="4" r="2"></circle>
                  </svg>
                </a>
                <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="dark-social-btn" aria-label="Instagram">
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
                    <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
                    <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
                  </svg>
                </a>
                <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="dark-social-btn" aria-label="YouTube">
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M22.54 6.42a2.78 2.78 0 0 0-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 2A29 29 0 0 0 1 11.75a29 29 0 0 0 .46 5.33A2.78 2.78 0 0 0 3.4 19c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-2 29 29 0 0 0 .46-5.25 29 29 0 0 0-.46-5.33z"></path>
                    <polygon points="9.75 15.02 15.5 11.75 9.75 8.48 9.75 15.02" fill="#0B0E14"></polygon>
                  </svg>
                </a>
              </div>
            </div>

          </div>

        </div>

        {/* Bottom Chennai Google Map Embed Section */}
        <div className="contact-map-container">
          <iframe
            title="DEXA Innovation Chennai Office Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d248849.886539092!2d80.06892495!3d13.0474878!2m3!1f0!0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a5265ea4f7d3361%3A0x6e61a70b6863d433!2sChennai%2C%20Tamil%20Nadu!5e0!3m2!1sen!2sin!4v1700000000000!5m2!1sen!2sin"
            width="100%"
            height="380"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>

      </div>
    </section>
  );
};

export default ContactSection;
